import { connect } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { getShopItemsStreamId } from '../../../../streams/shop';
import { ShopItemType } from '../../../../../types/shop';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { isCurrentUserProfileOwner } from '../../../../selectors/users';

const mapStateToProps = (state: AppState) => {
  const hasNoCommissionItems = !streamSelectors.getItems(
    state,
    getShopItemsStreamId(ShopItemType.COMMISSIONS)
  ).length;
  const hasNoPrints = !streamSelectors.getItems(
    state,
    getShopItemsStreamId(ShopItemType.PRINTS)
  ).length;
  const hasNoPremiumContentItems = !streamSelectors.getItems(
    state,
    getShopItemsStreamId(ShopItemType.PREMIUM_CONTENT)
  ).length;

  return {
    hasNoCommissions:
      hasNoCommissionItems && hasNoPrints && hasNoPremiumContentItems,
    isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
  };
};

export default connect(mapStateToProps);
